export default "/images/corner-right-up.svg?8cc65d098edfd5c076fbe86a72d8c907";